module.exports = __webpack_public_path__ + "img/become1.6cd8b76d.png";